/* eslint-disable max-len */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { printCouponPath } from '../../../../src/shared/format';
import Button from '../../../../modules/react/components/stateless/Button';
import { pushRoute } from '../../../../modules/routing';
import MediaGalleryImage from '../../../../modules/react/components/stateful/MediaGalleryImage';
import styles from './styles.scss';

const propTypes = {
  coupon: PropTypes.shape({
    style: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
  }),
  facilityId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  headerLogoMediumId: PropTypes.string,
};

const defaultProps = {
  coupon: undefined,
  headerLogoMediumId: undefined,
  onClose: undefined,
};

const PrintCoupon = ({
  coupon, facilityId, onClose, headerLogoMediumId,
}) => {
  const pathname = printCouponPath(coupon, facilityId);

  return (
    <div className={styles.modal}>
      <Modal.Header closeButton>
        <Modal.Title className={`${styles.header} color-primary-foreground`}>Coupon</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MediaGalleryImage mediumId={headerLogoMediumId} className={styles.image} />
        <div
          className={`${styles.couponHeader} color-primary-foreground`}
          dangerouslySetInnerHTML={{ __html: coupon.title }}
        />
        <div
          className={styles.blurb}
          dangerouslySetInnerHTML={{ __html: coupon.text }}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.finePrint}>
          Present this coupon at the facility above to take advantage of this special internet offer.
          Limit one offer per contract. Offer not redeemable for cash.
          Offer not valid for price adjustments on prior contracts.
          Offer cannot be used with any other promotions or discounts. Excludes applicable sales tax.
        </div>
        <Button onClick={onClose} variant="default">Cancel</Button>
        <Button
          variant="primary"
          className="color-secondary-background color-primary-background-hover"
          onClick={() => pushRoute(pathname)}
        >
          Print Coupon
        </Button>
      </Modal.Footer>
    </div>
  );
};

PrintCoupon.propTypes = propTypes;

PrintCoupon.defaultProps = defaultProps;

export default PrintCoupon;
